import getBasePath from '../functions/api-resource';

const basePath = getBasePath('workflow', 'configuracao');

const configuracaoActions = {
  setarRolesPerfilLogado: { method: 'PUT', url: `${basePath}/role/setar-roles-perfil-logado` },
};

export default (resource) => resource(`${basePath}`, {}, configuracaoActions);
